export type {
  MockedRequest,
  MockedResponse,
  MockLinkOptions,
  ResultFunction,
} from "./core/types/deprecated.js";
export { MockLink, realisticDelay } from "./core/mocking/mockLink.js";
export { MockSubscriptionLink } from "./core/mocking/mockSubscriptionLink.js";
